<template>
  <div class="ticket-card" @click="toggleSidebar">
    <div class="ticket-card-header">
      <div class="ticket-id">#{{ data.Id }}
        <div class="d-flex align-items-center gap-2">
          <div class="ticket-priority mr-1" :class="`priority-${data.Priority}`">
            <span class="priority-dot"></span>
            {{ getPriorityText(data.Priority) }}
          </div>
          <div class="ticket-badges" v-if="data.Source || data.Verified">
            <span class="badge badge-source" v-if="data.Source">{{ data.Source }}</span>
          </div>
        </div>
      </div>
      <div class="ticket-header-icons d-flex align-items-center">
        <div class="chat-icon">
          <span class="count-message">{{ data.UnreadMessageCount }}</span>
          <BIcon icon="chat-dots" class="mr-3 text-white"/>
        </div>
      </div>
    </div>

    <div class="ticket-title">
      {{ data.Title }}
    </div>

    <!--    <div class="ticket-meta">-->
    <!--      <div class="meta-row" v-if="data.Type">-->
    <!--        <svg class="meta-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">-->
    <!--          <path-->
    <!--              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>-->
    <!--        </svg>-->
    <!--        <span class="meta-text">{{ data.Type }}</span>-->
    <!--      </div>-->

    <!--      <div class="meta-row" v-if="data.Category">-->
    <!--        <svg class="meta-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">-->
    <!--          <path-->
    <!--              d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>-->
    <!--        </svg>-->
    <!--        <span class="meta-text">{{ data.Category }}</span>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="ticket-action-section">
      <div class="action-label">
        <span class="action-value">
          {{  (data.action?.name || 'Нет действия') }}
        </span>
        <div class="d-flex flex-column">
          <div class="ticket-user" v-if="data.User" @click.stop="navigateToUser(data.UserId)">
            <div class="user-avatar">
              {{ getInitials(data.User) }}
            </div>
            <span class="user-name">{{ data.User }}</span>
          </div>
          <div class="ticket-date">
            <svg class="date-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <span class="date-text">{{ formatDate(data.TicketDate) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";
import {BIcon} from "bootstrap-vue";

export default {
  name: 'TicketBoardCardTemplate',
  components: {BIcon},
  data() {
    return {
      data: {},
      selectedAction: null,
      selectedActionValue: null,
    };
  },
  methods: {
    getPriorityText(priority) {
      const priorities = {
        low: 'Низкий',
        medium: 'Средний',
        high: 'Высокий',
        urgent: 'Срочный'
      };
      return priorities[priority] || priority;
    },
    openHistory() {
      this.$emit('open-history', this.data?.Id);
    },

    async toggleSidebar() {
      this.$root.$emit('ticket-open-chat', this.data);
    },

    navigateToUser(userId) {
      // Открываем страницу пользователя в новой вкладке
      const route = this.$router.resolve(`/users/${userId}`);
      window.open(route.href, '_blank');
    },

    truncateText(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },

    getInitials(name) {
      if (!name) return '?';
      const parts = name.split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
      return date.toLocaleDateString('ru-RU', options);
    },

    onActionChange(value) {
      if (value && this.data.ActionOptions) {
        this.selectedAction = this.data.ActionOptions.find(option => option.value === value);
        this.$emit('action-changed', {
          ticketId: this.data.Id,
          action: this.selectedAction
        });
      } else {
        this.selectedAction = null;
      }
    },

    async updateTicketAction(actionId) {
      try {
        await api.tickets.updateActionFromTicket(this.data.Id, actionId)
        this.$toast.success('Действие обновлено')
        this.$root.$emit('ticket-action-updated')
      } catch (e) {
        this.$bvToast.toast(e.response.message || e.response.data.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      }
    },
  },
  watch: {
    'data.ActionId': {
      immediate: true,
      handler(newVal) {
        if (newVal && this.data.ActionOptions) {
          this.selectedActionValue = newVal;
          this.selectedAction = this.data.ActionOptions.find(option => option.value === newVal);
        }
      }
    },
    selectedActionValue: {
      handler(newVal) {
        this.updateTicketAction(newVal);
      }
    }
  }
};
</script>

<style scoped>
/* Компактная карточка */
.ticket-card {
  background: #ffffff;
  border-radius: 6px;
  padding: 8px 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  transition: all 0.15s ease;
  border-left: 3px solid #e5e7eb;
  cursor: pointer;
  min-width: 200px !important;
  font-size: 10px;
}

.ticket-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

/* Header */
.ticket-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.ticket-header-icons {
  color: white;
  font-size: 16px;
}

.ticket-header-icons .chat-icon {
  position: relative;
}

.ticket-header-icons .chat-icon span {
  position: absolute;
}

.count-message {
  position: absolute;
  top: 4px;
  right: 10px;
  min-width: 8px;
  height: 12px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: #667eea;
  color: white;
  font-size: 8px;
  font-weight: 600;
  line-height: 1;
}

.ticket-id {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  color: #6b7280;
  font-size: 9px;
}

.ticket-priority {
  height: 24px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 1px 4px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.priority-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
}

.priority-low {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #93c5fd;
}

.priority-low .priority-dot {
  background-color: #3b82f6;
}

.priority-medium {
  background-color: #fef3c7;
  color: #92400e;
  border: 1px solid #fde047;
}

.priority-medium .priority-dot {
  background-color: #f59e0b;
}

.priority-high {
  background-color: #fed7aa;
  color: #9a3412;
  border: 1px solid #fb923c;
}

.priority-high .priority-dot {
  background-color: #f97316;
}

.priority-urgent {
  background-color: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

.priority-urgent .priority-dot {
  background-color: #ef4444;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Title */
.ticket-title {
  font-size: 12px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 6px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Meta Information */
.ticket-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  margin-bottom: 2px;
  border-top: 1px solid #f3f4f6;
  border-bottom: 1px solid #f3f4f6;
}

.meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.meta-icon {
  width: 12px;
  height: 12px;
  color: #9ca3af;
  stroke-width: 2;
  flex-shrink: 0;
}

.meta-text {
  font-size: 11px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Action Section */

.action-label {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  font-size: 11px;
}


.action-value {
  color: #667eea;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.action-select {
  margin-top: 2px;
  font-size: 11px;
}

.ticket-user {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.user-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 600;
  flex-shrink: 0;
}

.user-name {
  font-size: 11px;
  color: #374151;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ticket-date {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 3px;
  margin-top: -10px;
  flex-shrink: 0;
}

.date-icon {
  width: 11px;
  height: 11px;
  color: #9ca3af;
  stroke-width: 2;
}

.date-text {
  font-size: 10px;
  color: #9ca3af;
  white-space: nowrap;
}

/* Badges */
.ticket-badges {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  height: 24px;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
}

.badge-source {
  background-color: #ede9fe;
  color: #6d28d9;
  border: 1px solid #c4b5fd;
  border-radius: 10px;
}

.badge-verified {
  background-color: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}

.badge-verified svg {
  width: 10px;
  height: 10px;
}

/* Dark theme support */
@media (prefers-color-scheme: dark) {
  .ticket-card {
    background: #1f2937;
    border-left-color: #374151;
  }

  .ticket-title {
    color: #f9fafb;
  }

  .meta-text,
  .user-name,
  .action-title {
    color: #d1d5db;
  }

  .ticket-id {
    color: #9ca3af;
  }

  .ticket-meta,
  .ticket-footer {
    border-color: #374151;
  }
}
</style>
